<template>
  <div>
    <el-dialog  width="495px" :show-close="false" custom-class="system-dialog" :visible.sync="visible" :close-on-click-modal="false">
      <div class="title" style="position: relative;font-size: 20px;">系统提示
        <span v-if="tipType == 2"  @click="handleClose" style="cursor: pointer;">
          <i class="el-icon-close" style="position: absolute;right: -5px;top:0px;font-size: 18px;"></i>
        </span>
      </div>

      <div class="tip-box">
        <i class="el-icon-warning warning-icon"></i>
        <span>请填写您的联系方式，以便接收店铺营销数据、异常信息通知</span>
      </div>
      <div class="form-box">
        <div class="form-item">
          <div class="item-label">手机号：</div>
          <div class="item-value">
            <el-input placeholder="请输入..." v-model="phone" style="width: 280px"></el-input>
          </div>
        </div>
        <div class="form-item">
          <div class="item-label">验证码：</div>
          <div class="item-value">
            <el-input placeholder="请输入" v-model="code" style="width: 170px; margin-right: 12px"></el-input>
            <el-button type="primary" :disabled="codeDisabled" @click="getCode">{{ codeMsg }}</el-button>
          </div>
        </div>
        <div class="form-item" style="margin-bottom: 8px">
          <!-- <div class="item-label"></div> -->
          <!-- <div class="item-value">
            <div class="tip-box" style="background: #fff">
              <i class="el-icon-warning warning-icon"></i>
              <span
                >设置成功后，系统自动赠送<span>300</span
                ><span>条短信</span></span
              >
            </div>
          </div> -->
          <div class="form-item" style="margin-bottom: 8px">
            <div class="item-label"></div>
            <div class="item-value">
              <div class="tip-box" style="background: #fff">
                <i class="el-icon-warning warning-icon" v-if="getGiveSmsCountNum > 0"></i>
                <span v-if="getGiveSmsCountNum > 0"
                  >设置成功后，赠送<span>{{ getGiveSmsCountNum }}</span
                  ><span>条短信</span></span
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="save-btn">
        <el-button type="primary" :disabled="saveDisable" @click="savePhone">立即保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { checkCodeSet, updateShopMobile, querySellerSetting } from "@/api/backstage/a_setting"; //判断是否有绑定手机号
import { getSellerInfo, getGiveSmsCount } from "@/api/sellerController";
export default {
  name: "",
  props:{
    tipType:{
      type:Number,
    }
  },
  data() {
    return {
      visible: false,
      phone: "",
      code: "",
      timer: null, //验证码定时
      successMsg: "",
      countdown: 60, // 倒计时s
      codeMsg: "获取验证码", // 按钮上的文字
      codeDisabled: false, // 按钮可点击，是否绑定手
      saveDisable: false,
      getGiveSmsCountNum: 0,
    };
  },
  mounted() {
    //  querySellerSetting({
    //       "Accept": "*/*"
    //   }).then((res)=>{
    //     if (res.data.sellerVO.mobile !="") {
    //       this.visible = false;
    //     }else {
    //       this.visible = true;
    //     }
    //   })
    console.log("system-dialog");
    getSellerInfo().then((res) => {
      if (!res.data.isBindPhone) {
        this.visible = false;
        this.$parent.showActive();
      } else {
        this.visible = true;
      }
    });
    getGiveSmsCount().then((res) => {
      this.getGiveSmsCountNum = res.data ? res.data * 1 : 0;
    });
  },
  methods: {
    ...mapMutations({
      editUserInfo: "LOGINUSERINFO",
    }),

    /**  保存  */
    savePhone() {
      if (!this.phone) {
        this.$message.warning("请输入手机号");
        return;
      }
      if (!this.code) {
        this.$message.warning("请输入验证码");
        return;
      }

      var param = {
        mobile: this.phone,
        vcode: this.code,
      };
      this.saveDisable = true;
      updateShopMobile(param).then((res) => {
        console.log(res);

        this.saveDisable = false;
        if (res.code == "1" || res.isFirst === 0 || res.isFirst === 1) {
          this.$parent.showActive();
          // this.handleClose();
          this.$emit("close");
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /** 获取验证码 */
    getCode() {
      if (!this.phone) {
        this.$message({
          message: "请输入手机号",
          type: "warning",
        });
        return;
      }

      if (!this.timer) {
        let obj = {
          bindingPhone: this.phone,
        };
        this.codeDisabled = true;
        checkCodeSet(obj).then((res) => {
          if (res.code == 1) {
            // this.successMsg = res.message;
          } else {
            this.$message.error(res.data.message);
          }
        });

        this.timer = setInterval(() => {
          if (this.countdown > 0 && this.countdown <= 60) {
            this.countdown--;
            if (this.countdown !== 0) {
              this.codeMsg = "重新发送(" + this.countdown + ")";
            } else {
              clearInterval(this.timer);
              this.codeMsg = "获取验证码";
              this.countdown = 60;
              this.timer = null;
              this.codeDisabled = false;
            }
          }
        }, 1000);
      }
    },
    handleClose() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.system-dialog {
  .el-dialog__body {
    padding: 16px 30px 30px 30px;
  }
  .form-box {
    padding-top: 16px;
    .form-item {
      font-size: 14px;
      color: #333;
      margin-bottom: 12px;
      .item-label {
        display: inline-block;
        width: 76px;
        text-align: right;
      }
      .item-value {
        display: inline-block;
      }
    }
  }
  .save-btn {
    text-align: center;
  }
}
.tip-box {
  padding-left: 24px;
  text-align: left;
  line-height: 21px;
  font-size: 14px;
  // margin-top: 12px;
  color: #999999;
  background: #fafafa;
  position: relative;
  // margin: 20px 28px 20px 28px;
  line-height: 42px;
  .warning-icon {
    color: #fe8f8a;
    font-size: 14px;
    position: absolute;
    left: 5px;
    top: 13px;
  }
}  .title {
    font-size: 20px;
    font-weight: 600;
    color: #212533;
    text-align: left;
    margin-top: -50px;
    margin-bottom: 40px;
  }
</style>
